import { createServiceURL } from 'shared/utils'

const usersModule = 'users'
const meEndpoint = 'me'

export const aboutEndpoint = createServiceURL(usersModule, meEndpoint)
